export default class formConfig {
  // 招标公告信息
  static tendererNoticeInfo() {
    return [
      {
        title: "项目信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标项目名称：",
            value: "tenderPrjName",
            type: "slot",
            slotName: "tenderPrjName",
            disabled: true,
            width: "100%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "标段数/采购包：",
            value: "sectionQuantity",
            type: "slot",
            slotName: "sectionQuantity",
            width: "100%",
          },
          {
            label: "行政监督部门：",
            value: "regulators",
            type: "slot",
            slotName: "regulators",
            width: "100%",
          },
          {
            label: "行政监督部门电话：",
            value: "supervisionDeptTel",
            type: "input",
            maxlength: 12,
            required: true,
            disabled: false,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/,
                message: "输入的部门电话不正确！",
              },
            ]
          },
          {
            label: "合格投标人的数量：",
            value: "qualifiedBidNumber",
            type: "input",
            required: true,
            disabled: false,
            maxlength: 300,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标文件下载方式：",
            value: "registrationMode",
            type: "select",
            placeholder: "请选择",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510261753170002",
            }
          },
          {
            label: "招标文件下载网址：",
            value: "registrationUrl",
            type: "input",
            disabled: false,
          },
          {
            label: "文件下载起始时间：",
            value: "noticeStartDate",
            type: "date",
            dateType: "datetime",
            disabled: false,
            required: true,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            popperClass: "noBtn",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
            TimePickerOptions: {
              disabledDate(time) {
                return time.getTime() < Date.now() - 24 * 60 * 60 * 1000; // 此条为设置禁止用户选择今天之前的日期，不包含今天
              },
            }
          },
          {
            label: "文件下载截止时间：",
            value: "noticeEndDate",
            type: "date",
            dateType: "datetime",
            disabled: false,
            required: true,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            popperClass: "noBtn",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
            TimePickerOptions: {
              disabledDate(time) {
                return time.getTime() < Date.now() - 24 * 60 * 60 * 1000; // 此条为设置禁止用户选择今天之前的日期，不包含今天
              },
            }
          },    
          {
            label: "评标办法：",
            value: "evaluationMethod",
            type: "slot",
            slotName: "evaluationMethod",
            tip: "请认真选择项目的评标办法，若项目为电子标，则该评标办法即为电子标书的制式文本",
            required: true,
            width: "100%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "本次招标投资额（万元）：",
            value: "totalInvestment",
            type: "input",
            maxlength: 30,
            required: false,
            rule: [
              {
                required: false,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^(0|0(?:\.\d{1,4})?|[1-9]\d{0,7}(?:\.\d{1,6})?)$/,
                message: "请输入整数最多8位，小数最多6位的数字"
              }
            ]
          },
          {
            label: "公告发布责任人：",
            value: "bulletinDuty",
            type: "input",
            required: true,
            maxlength: 50,
            disabled: false,
            tip: "填写公告发布的责任人姓名、职务",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "公告状态：",
            value: "noticeState",
            type: "slot",
            slotName: "noticeState",
            class: "noticeState",
          },
          {

            label: "公告发布媒体：",
            value: "bulletinMedia",
            type: "textarea",
            required: true,
            disabled: false,
            maxlength: 1250,
            tip: "可填1250个汉字",
            width: "100%;",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标文件获取方式：",
            value: "tenderDocType",
            type: "textarea",
            disabled: false,
            maxlength: 300,
            tip: "可填300个汉字",
            width: "100%;",
          },
          {
            label: "其它要求：",
            value: "otherRequirememts",
            type: "textarea",
            disabled: false,
            maxlength: 1250,
            tip: "可填1250个汉字",
            width: "100%;",
          },
          {
            label: "备注：",
            value: "description",
            type: "textarea",
            disabled: false,
            maxlength: 1250,
            tip: "可填1250个汉字",
            width: "100%;",
          },
        ]
      },
    ];
  }
  // 招标计划信息
  static biddingPlanInfo() {
    return [
      {
        title: "招标计划信息",
        name: "1",
        icon: "",
        class: "biddingPlan",
        formConfigList: [
          {
            label: "投资项目代码：",
            value: "planInvestProjectCode",
            type: "input",
            disabled: true,
          },
          {
            label: "投资项目名称：",
            value: "planInvestProjectName",
            type: "input",
            disabled: true,
          },
          {
            label: "招标项目名称：",
            value: "planProjectName",
            type: "input",
            disabled: true,
          },
          {
            label: "招标项目建设地点：",
            value: "planProjectPlace",
            type: "input",
            disabled: true,
          },
          {
            label: "招标项目类型：",
            value: "planTenderProjectTypeName",
            type: "input",
            disabled: true,
          },
          {
            label: "招标方式：",
            value: "planTenderTypeName",
            type: "input",
            disabled: true,
          },
          {
            label: "招标人：",
            value: "planTenderCorpName",
            type: "input",
            disabled: true,
          },
          {
            label: "发布人名称：",
            value: "planIssueName",
            type: "input",
            disabled: true,
          },
          {
            label: "预估发包价（元）：",
            value: "planContractPrice",
            type: "input",
            disabled: true,
          },
          {
            label: "招标公告预计发布时间：",
            value: "planNoticeReleaseTime",
            type: "input",
            disabled: true,
          },
          {
            label: "招标计划发布时间：",
            value: "planReleaseTime",
            type: "input",
            disabled: true,
          },
          {
            label: "行政监督部门：",
            value: "planRegulatorsName",
            type: "input",
            disabled: true,
          },
          {
            label: "项目概况：",
            value: "planProjectOverview",
            type: "textarea",
            width: "100%;",
            disabled: true,
          },
          {
            label: "招标内容：",
            value: "planTenderContent",
            type: "textarea",
            width: "100%;",
            disabled: true,
          },
        ]
      },
    ]
  }
  // 招标文件信息（非电子标）
  static nonEleBiddingDocumentInfo() {
    return [
      {
        title: "招标文件信息",
        tip: "（若为非电子标资格后审项目，请直接上传招标文件）",
        tipColor: "#FF8918",
        name: "1",
        icon: "",
        class: "file-upload-form",
        formConfigList: [
          {
            label: "标段：",
            type: "slot",
            slotName: "bidDocument",
            width: "100%;",
          },
          {
            label: "",
            type: "slot",
            class: "table formList",
            slotName: "nonElebidDocument",
          }
        ]
      },
    ]
  }
  // 招标文件信息
  static biddingDocumentInfo() {
    return [
      {
        title: "招标文件信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "table formList",
            slotName: "bidDocumentList",
          },
        ]
      },
    ]
  }
  // 资格预审公告信息
  static prequalificationInfo() {
    return [
      {
        title: "公告内容",
        tipColor: "#FF8918",
        name: "1",
        icon: "",
        class: "noticeInfo",
        formConfigList: [
          {
            label: "资格预审文件获取方式：",
            value: "acquisitionMode",
            type: "select",
            placeholder: "请选择",
            required: true,
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201511101431490014",
            },
            rule: {
              required: true,
              message: "请选择",
              trigger: "change"
            },
          },
          {
            label: "资格预审结果公示开始时间：",
            value: "publicityStartDate",
            type: "date",
            dateType: "datetime",
            disabled: false,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            TimePickerOptions: {
              disabledDate(time) {
                //此条为设置禁止用户选择今天之前的日期，包含今天。
                return time.getTime() <= (Date.now());
              },
            }
          },
          {
            label: "资格预审结果公示截止时间：",
            value: "publicityEndDate",
            type: "date",
            dateType: "datetime",
            disabled: false,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            TimePickerOptions: {
              disabledDate(time) {
                //此条为设置禁止用户选择今天之前的日期，包含今天。
                return time.getTime() <= (Date.now());
              },
            }
          },
          {
            label: "资格预审申请书送达地点：",
            value: "fileDeliveryAddress",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 300,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "资格预审结果通知时间：",
            value: "resultNotificationDate",
            type: "input",
            disabled: false,
          },
          {
            label: "资格预审申请书送达截止时间：",
            value: "requisitionEndDate",
            type: "date",
            dateType: "datetime",
            disabled: false,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            TimePickerOptions: {
              disabledDate(time) {
                //此条为设置禁止用户选择今天之前的日期，包含今天。
                return time.getTime() <= (Date.now());
              },
            },
          },
          {
            label: "接收资格预审文件申请书单位：",
            value: "requisitionCorp",
            type: "input",
            maxlength: 100,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "资格预审申请文件递交方法：",
            value: "applicationDocReferMethod",
            type: "textarea",
            width: "100%;",
            maxlength: 300,
            disabled: false,
          },
        ]
      },
      {
        title: "资格预审文件信息",
        tipColor: "#FF8918",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "资格预审文件：",
            value: "requisitionFilePath",
            type: "slot",
            width: "100%;",
            slotName: "prequalification",
          },
          {
            label: "",
            type: "slot",
            class: "table formList",
            slotName: "prequalificationList",
          }
        ]
      },
    ]
  }
  // 其他
  static other() {
    return [
      {
        title: "异议受理部门信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "table formList",
            slotName: "objectionList"
          }
        ]
      },
      {
        title: "公告变更信息",
        name: "2",
        icon: "",
        class: "modifyInfo",
        formConfigList: [
          {
            label: "申请变更状态：",
            type: "slot",
            slotName: "modifyNoticeStateName"
          },
          {
            label: "变更原因：",
            value: "modifyMark",
            type: "textarea",
            maxlength: 1250,
            tip: "可填1250个汉字",
            width: "100%;",
            disabled: false,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "历史记录：",
            type: "slot",
            slotName: "hisBtn"
          }
        ]
      },
      {
        title: "其他",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "招标人意见：",
            type: "slot",
            width: "100%",
            class: "formTextarea",
            maxlength: 500,
            slotName: "tenderOpinion"
          },
        ]
      },
    ]
  }
}
